import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
const _excluded = ["detached", "size", "hovered"];
import styled from 'foundations-theming/utils';
import { HoverProvider } from '../HoverProvider';
import { CloseButton } from '../CloseButton';
import { usePanelContext } from '../../context/PanelContext';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCloseButtonWrapper = styled(props => {
  const rest = Object.assign({}, (_objectDestructuringEmpty(props), props));
  return /*#__PURE__*/_jsx(CloseButton, Object.assign({}, rest));
}).withConfig({
  displayName: "DialogCloseButton__StyledCloseButtonWrapper"
})(["top:", ";"], ({
  theme
}) => theme.space['600']);
export const DialogCloseButton = _ref => {
  let {
      detached = false,
      size,
      hovered
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    inPanel
  } = usePanelContext();
  const computedSize = detached && size == null ? 'xl' : size;
  return /*#__PURE__*/_jsx(HoverProvider, Object.assign({}, rest, {
    children: hoverProviderProps => /*#__PURE__*/_jsx(StyledCloseButtonWrapper, Object.assign({}, rest, hoverProviderProps, {
      detached: detached,
      size: computedSize,
      hovered: hovered
    }, inPanel && {
      'data-panel-close-button': 'true'
    }))
  }));
};
DialogCloseButton.displayName = 'DialogCloseButton';